import 'babel-polyfill';
// import './vendors'; // 各种库文件
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Provider } from 'mobx-react';
import 'antd/dist/antd.css';
import stores from './stores';
import { routes } from './routers';
// import registerServiceWorker from './registerServiceWorker';
import auth from './service/auth-manager';
import './styles/reset.scss';
import '@components/Notification';
import { LocaleProvider } from 'antd';
import zhCN from 'antd/lib/locale-provider/zh_CN';
import Login from './view/Login/login';
import Agreement from './view/home/agreement';
import Privacy from './view/home/privacy';
import Agreement2 from './view/home/ud_agreement';
import Privacy2 from './view/home/ud_privacy';
import { NOTLOGIN_URL } from './service/constant';
import ZhuyunLogin from '@root/service/zhuyunLogin';

// console.log(process.env)
// react渲染前启动各种服务
auth.init(process.env.BUILD_TO).registDefaultInterceptors();

(async () => {
  try {
    await ZhuyunLogin.judgeZhuyunConfig();
    if (!NOTLOGIN_URL.some((o) => window.location.hash.includes(o))) {
      await ZhuyunLogin.getPageFrom();
    }
    let RoutesConfig = () => (
      <Provider stores={stores}>
        <LocaleProvider locale={zhCN}>
          <div id="root-content">
            <Router>
              <Switch>
                <Route path="/agreement" component={Agreement} />
                <Route path="/privacy" component={Privacy} />
                <Route path="/ud_agreement" component={Agreement2} />
                <Route path="/ud_privacy" component={Privacy2} />
                {routes.map((route, index) => (
                  <Route
                    key={index}
                    path={route.path}
                    exact
                    render={(props) => <route.component {...props} routes={route.routes} />}
                  />
                ))}
                <Route component={Login} />
              </Switch>
            </Router>
          </div>
        </LocaleProvider>
      </Provider>
    );
    ReactDOM.render(<RoutesConfig />, document.getElementById('root'));
  } catch (err) {
    console.log('-----出错err-----');
  }
})();
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js